import { render, staticRenderFns } from "./ColoredTitle.vue?vue&type=template&id=e090ad84&"
import script from "./ColoredTitle.vue?vue&type=script&lang=ts&"
export * from "./ColoredTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports